"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartRemovalConfirmationCardCms = void 0;
var CartRemovalConfirmationCardCms = /** @class */ (function () {
    function CartRemovalConfirmationCardCms() {
        this.removeItemLabel = 'Are you sure you want to remove the following items?';
        this.confirmationConsentLabel = "Please note that after these lines are removed, we'll'\n        see if you need to make a security payment to start your new service";
        this.installmentAmountLabel = 'monthly payments of $';
    }
    return CartRemovalConfirmationCardCms;
}());
exports.CartRemovalConfirmationCardCms = CartRemovalConfirmationCardCms;
//# sourceMappingURL=CartRemovalConfirmationCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditResponseModal/CartRemovalConfirmationCard/CartRemovalConfirmationCard.cms.js
// module id = 2014
// module chunks = 8